import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MessageService } from 'primeng/api';
import { PrimeNG } from 'primeng/config';
import { DialogService } from 'primeng/dynamicdialog';
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'app-main',
  templateUrl: './main.html',
  styleUrl: './main.css',
  imports: [RouterOutlet, ToastModule],
  providers: [MessageService, DialogService],
})
export class Main implements OnInit {
  private config = inject(PrimeNG);

  ngOnInit() {
    this.config.setTranslation({
      startsWith: $localize`Inizia con`,
      contains: $localize`Contiene`,
      notContains: $localize`Non contiene`,
      endsWith: $localize`Finisce con`,
      equals: $localize`Uguale`,
      notEquals: $localize`Non uguale`,
      noFilter: $localize`Nessun filtro`,
      lt: $localize`Minore di`,
      lte: $localize`Minore o uguale a`,
      gt: $localize`Maggiore di`,
      gte: $localize`Maggiore o uguale a`,
      is: $localize`È`,
      isNot: $localize`Non è`,
      before: $localize`Prima`,
      after: $localize`Dopo`,
      dateIs: $localize`La data è`,
      dateIsNot: $localize`La data non è`,
      dateBefore: $localize`La data è prima`,
      dateAfter: $localize`La data è dopo`,
      clear: $localize`Cancella`,
      apply: $localize`Applica`,
      matchAll: $localize`Tutti`,
      matchAny: $localize`Almeno uno`,
      addRule: $localize`Aggiungi regola`,
      removeRule: $localize`Rimuovi regola`,
      accept: $localize`Sì`,
      reject: $localize`No`,
      choose: $localize`Scegli`,
      upload: $localize`Carica`,
      cancel: $localize`Annulla`,
      dayNames: [
        $localize`Domenica`,
        $localize`Lunedì`,
        $localize`Martedì`,
        $localize`Mercoledì`,
        $localize`Giovedì`,
        $localize`Venerdì`,
        $localize`Sabato`,
      ],
      dayNamesShort: [
        $localize`Dom`,
        $localize`Lun`,
        $localize`Mar`,
        $localize`Mer`,
        $localize`Gio`,
        $localize`Ven`,
        $localize`Sab`,
      ],
      dayNamesMin: [
        $localize`Do`,
        $localize`Lu`,
        $localize`Ma`,
        $localize`Me`,
        $localize`Gi`,
        $localize`Ve`,
        $localize`Sa`,
      ],
      monthNames: [
        $localize`Gennaio`,
        $localize`Febbraio`,
        $localize`Marzo`,
        $localize`Aprile`,
        $localize`Maggio`,
        $localize`Giugno`,
        $localize`Luglio`,
        $localize`Agosto`,
        $localize`Settembre`,
        $localize`Ottobre`,
        $localize`Novembre`,
        $localize`Dicembre`,
      ],
      monthNamesShort: [
        $localize`Gen`,
        $localize`Feb`,
        $localize`Mar`,
        $localize`Apr`,
        $localize`Mag`,
        $localize`Giu`,
        $localize`Lug`,
        $localize`Ago`,
        $localize`Set`,
        $localize`Ott`,
        $localize`Nov`,
        $localize`Dic`,
      ],
      today: $localize`Oggi`,
      weekHeader: $localize`Sm`,
      weak: $localize`Debole`,
      medium: $localize`Medio`,
      strong: $localize`Forte`,
      passwordPrompt: $localize`Inserisci una password`,
      emptyMessage: $localize`Nessun risultato trovato`,
      emptyFilterMessage: $localize`Nessun risultato trovato`,
      searchMessage: $localize`{0} risultati disponibili`,
      selectionMessage: $localize`{0} elementi selezionati`,
      emptySelectionMessage: $localize`Nessun elemento selezionato`,
      emptySearchMessage: $localize`Nessun risultato trovato`,
      fileChosenMessage: $localize`{0} file`,
      noFileChosenMessage: $localize`Nessun file scelto`,
      aria: {
        trueLabel: $localize`Vero`,
        falseLabel: $localize`Falso`,
        nullLabel: $localize`Non selezionato`,
        star: $localize`1 stella`,
        stars: $localize`{star} stelle`,
        selectAll: $localize`Tutti gli elementi selezionati`,
        unselectAll: $localize`Tutti gli elementi deselezionati`,
        close: $localize`Chiudi`,
        previous: $localize`Precedente`,
        next: $localize`Successivo`,
        navigation: $localize`Navigazione`,
        scrollTop: $localize`Scorri in alto`,
        moveTop: $localize`Sposta in alto`,
        moveUp: $localize`Sposta su`,
        moveDown: $localize`Sposta giù`,
        moveBottom: $localize`Sposta in fondo`,
        moveToTarget: $localize`Sposta in destinazione`,
        moveToSource: $localize`Sposta in origine`,
        moveAllToTarget: $localize`Sposta tutto in destinazione`,
        moveAllToSource: $localize`Sposta tutto in origine`,
        pageLabel: $localize`Pagina {page}`,
        firstPageLabel: $localize`Prima pagina`,
        lastPageLabel: $localize`Ultima pagina`,
        nextPageLabel: $localize`Pagina successiva`,
        prevPageLabel: $localize`Pagina precedente`,
        rowsPerPageLabel: $localize`Righe per pagina`,
        jumpToPageDropdownLabel: $localize`Vai al menu a tendina della pagina`,
        jumpToPageInputLabel: $localize`Vai all'input della pagina`,
        selectRow: $localize`Riga selezionata`,
        unselectRow: $localize`Riga deselezionata`,
        expandRow: $localize`Riga espansa`,
        collapseRow: $localize`Riga compressa`,
        showFilterMenu: $localize`Mostra menu filtro`,
        hideFilterMenu: $localize`Nascondi menu filtro`,
        filterOperator: $localize`Operatore filtro`,
        filterConstraint: $localize`Vincolo filtro`,
        editRow: $localize`Modifica riga`,
        saveEdit: $localize`Salva modifica`,
        cancelEdit: $localize`Annulla modifica`,
        listView: $localize`Vista lista`,
        gridView: $localize`Vista griglia`,
        slide: $localize`Scorri`,
        slideNumber: $localize`{slideNumber}`,
        zoomImage: $localize`Ingrandisci immagine`,
        zoomIn: $localize`Ingrandisci`,
        zoomOut: $localize`Rimpicciolisci`,
        rotateRight: $localize`Ruota a destra`,
        rotateLeft: $localize`Ruota a sinistra`,
      },
    });
  }
}
